import React from "react"
import Select from "react-select"

const PropertyType = ({ selectOptions, propertyVal, handleChange }) => {
  // console.log("selectOptions", selectOptions)
  return (
    <div className="select-option dropdown">
      <Select
        options={selectOptions}
        placeholder="Property Types"
        className="react-select"
        classNamePrefix="react-select"
        onChange={(event) => handleChange(event.value)}
        value={selectOptions.filter((item) => item.value === propertyVal)}
      />
    </div>
  )
}
export default PropertyType
